/**
 * Get the list column definition
 * @category List View
 * @ignore - Do not document
 */ export var gridListColumnSelector = function(state) {
    return state.listViewColumn;
};
